export enum BroadcastStatus {
  NEW = 'NEW',
  SCHEDULING = 'SCHEDULING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum BroadcastBatchStatus {
  SCHEDULED = 'SCHEDULED',
  PROCESSING = 'PROCESSING',
  SENT = 'SENT',
  FAILED = 'FAILED',
}

export enum BroadcastUserStatus {
  SENT = 'SENT',
  RECEIVED = 'RECEIVED',
  CLICKED = 'CLICKED',
}
